<template>
	<div class="app-container">
		<!--查询组-->
		<div class="filter-container">
			<el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
				<el-form-item prop="keyword">
					<el-input v-model="listQuery.keyword" placeholder="请输入昵称/手机号/年龄" clearable @keyup.enter.native="SearchData" />
				</el-form-item>
				<el-form-item prop="status">
					<el-select v-model="listQuery.status" placeholder="请选择状态" clearable @keyup.enter.native="SearchData">
						<el-option label="启用" :value="1"></el-option>
						<el-option label="禁用" :value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="is_member">
					<el-select v-model="listQuery.is_member" placeholder="是否会员" clearable @keyup.enter.native="SearchData">
						<el-option label="是" :value="1"></el-option>
						<el-option label="否" :value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="is_blacklist">
					<el-select v-model="listQuery.is_blacklist" placeholder="是否黑名单" clearable @keyup.enter.native="SearchData">
						<el-option label="是" :value="1"></el-option>
						<el-option label="否" :value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
					<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!--动作组-->
		<div class="action-container">
			<el-button-group>
				<!-- 弹窗层编辑 -->
				<el-button v-auth="'User.create'" class="action-item" type="primary" icon="el-icon-edit"
					@click="HandleCreate">添加</el-button>
				<el-button v-auth="'User.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
			</el-button-group>
		</div>
		<!--表开始-->
		<el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row
			style="width: 100%" @sort-change="sortChange">
			<el-table-column align="center" type="selection" />
			<el-table-column align="center" prop="avatar" label="头像" width="120">
				<template slot-scope="{ row }">
					<el-avatar :size="60" :src="row.avatar" @error="true">
						<img :src="base_url+'uploads/default_avatar.png'">
					</el-avatar>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="nickname" label="昵称" />
			<el-table-column align="center" prop="phone" label="手机号" width="140" />
			<el-table-column align="center" label="状态" width="100" column-key="status" prop="status"
				:filters="[{ text: '启用', value: 1 }, { text: '禁用', value: 0 }]" :filter-method="filterHandler">
				<template slot-scope="{ row }">
					<el-switch v-model="row.status" :active-value="1" :inactive-value="0" @change="changeState(row)" />
				</template>
			</el-table-column>
			<el-table-column align="center" prop="gender" label="性别" width="80">
				<template slot-scope="{ row }">
					{{ row.gender | genderFilter }}
				</template>
			</el-table-column>
			<el-table-column align="center" prop="age" label="年龄" width="80" />
			<el-table-column align="center" prop="money" label="余额" width="120" />
			<el-table-column align="center" prop="is_member" label="是否会员" width="100">
				<template slot-scope="{ row }">
					{{ row.is_member==1?'是':'否' }}
				</template>
			</el-table-column>
			<el-table-column align="center" prop="is_coach" label="是否教练" width="100">
				<template slot-scope="{ row }">
					{{ row.is_coach==1?'是':'否' }}
				</template>
			</el-table-column>
			<el-table-column align="center" prop="" label="操作" width="420">
				<template slot-scope="scopes">
					<div class="user-op-btns">
						<div class="user-op-row">
							<el-button v-auth="'User.details'" plain icon="el-icon-document" size="mini"
								@click="HandleDetails(scopes.row)">详情</el-button>
							<el-button v-auth="'User.edit'" plain type="primary" icon="el-icon-edit" size="mini"
								@click="HandleUpdate(scopes.row)">编辑</el-button>
							<el-button v-auth="'User.delete'" size="mini" plain type="danger" icon="el-icon-delete"
								@click="RowDelete(scopes.row)">删除</el-button>
						</div>
						<div class="user-op-row">
							<el-button v-auth="'User.money'" size="mini" plain type="info" icon="el-icon-money"
								@click="moneylsit(scopes.row)">余额记录</el-button>
							<el-button v-auth="'User.adjust'" size="mini" plain type="warning" icon="el-icon-wallet-outlined"
								@click="HandleAdjustMoney(scopes.row)">调整余额</el-button>
						<el-button v-if="scopes.row.is_blacklist == 0" v-auth="'User.blacklist'" plain type="warning" size="mini"
							@click="changeBlacklist(scopes.row,1)">加入黑名单</el-button>
							<el-button v-if="scopes.row.is_blacklist == 1" v-auth="'User.blacklist'" plain type="success" size="mini"
							@click="changeBlacklist(scopes.row,2)">移除黑名单</el-button>
						</div>
					</div>
				</template>
			</el-table-column>
			<!--列结束-->
		</el-table>
		<!--分页-->
		<pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
			@pagination="loadData" />
		<!--弹窗编辑/新增窗体-->
		<el-dialog :title="dialogStatus == 'create' ? '新增' : '编辑'" :visible.sync="dialogFormVisible" width="1030px"
			top="8vh">
			<el-form ref="dataForm" :rules="rules" :inline="true" :model="temp" label-position="right" label-width="100px"
				style="height:65vh;overflow-y:scroll;margin-left:10px;padding-right:10px;">
				<el-form-item label="头像" prop="avatar">
					<FileList v-model="temp.avatar" :item-width="80" :item-height="80" :limit="1" type="image"
						style="width:300px;" />
				</el-form-item>
				<br>
				<el-form-item label="昵称" prop="nickname">
					<el-input v-model="temp.nickname" placeholder="请输入昵称" style="width:200px;" />
				</el-form-item>
				<el-form-item label="手机号" prop="phone">
					<el-input v-model="temp.phone" :disabled="dialogStatus != 'create'" placeholder="请输入手机号"
						style="width:200px;" />
				</el-form-item>
				<el-form-item label="性别" prop="gender">
					<el-radio-group v-model="temp.gender" style="width:200px;">
						<el-radio :label="1">男</el-radio>
						<el-radio :label="2">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="年龄" prop="age">
					<el-input-number v-model="temp.age" :min="1" :max="100" placeholder="请输入年龄"
						style="width:200px;"></el-input-number>
				</el-form-item>
				<el-form-item label="状态" prop="status">
					<el-radio-group v-model="temp.status" style="width:200px;">
						<el-radio :label="1">启用</el-radio>
						<el-radio :label="0">禁用</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="是否可被邀约" prop="is_invite">
					<el-radio-group v-model="temp.status" style="width:200px;">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="发球成功率" prop="serveSuccessRate">
					<el-input v-model.number="temp.serveSuccessRate" disabled placeholder="请输入发球成功率" style="width:200px;">
						<i slot="suffix">%</i>
					</el-input>
				</el-form-item>
				<el-form-item label="发球ace次数" prop="serveAceCount">
					<el-input-number v-model="temp.serveAceCount" disabled :min="1" placeholder="请输入发球ace次数" style="width:200px;"
						controls-position="right"></el-input-number>
				</el-form-item>
				<el-form-item label="发球速度" prop="serveSpeed">
					<el-input v-model.number="temp.serveSpeed" disabled placeholder="请输入发球速度" style="width:200px;">
						<i slot="suffix">km/h</i>
					</el-input>
				</el-form-item>
				<el-form-item label="接发球成功率" prop="receiveSuccessRate">
					<el-input v-model.number="temp.receiveSuccessRate" disabled placeholder="请输入接发球成功率" style="width:200px;">
						<i slot="suffix">%</i>
					</el-input>
				</el-form-item>
				<el-form-item label="接发球破发率" prop="breakPointConversionRate">
					<el-input v-model.number="temp.breakPointConversionRate" disabled placeholder="请输入接发球破发率"
						style="width:200px;">
						<i slot="suffix">%</i>
					</el-input>
				</el-form-item>
				<el-form-item label="击球成功率" prop="hitSuccessRate">
					<el-input v-model.number="temp.hitSuccessRate" disabled placeholder="请输入击球成功率" style="width:200px;">
						<i slot="suffix">%</i>
					</el-input>
				</el-form-item>

				<el-form-item label="正手击球率" prop="forehandHitRate">
					<el-input v-model.number="temp.forehandHitRate" disabled placeholder="请输入正手击球率" style="width:200px;">
						<i slot="suffix">%</i>
					</el-input>
				</el-form-item>
				<el-form-item label="反手击球率" prop="backhandHitRate">
					<el-input v-model.number="temp.backhandHitRate" disabled placeholder="请输入反手击球率" style="width:200px;">
						<i slot="suffix">%</i>
					</el-input>
				</el-form-item>
				<el-form-item label="底线得分率" prop="baselineScoreRate">
					<el-input v-model.number="temp.baselineScoreRate" disabled placeholder="请输入底线得分率" style="width:200px;">
						<i slot="suffix">%</i>
					</el-input>
				</el-form-item>

				<el-form-item label="平均击球速度" prop="averageHitSpeed">
					<el-input v-model.number="temp.averageHitSpeed" disabled placeholder="请输入平均击球速度" style="width:200px;">
						<i slot="suffix">km/h</i>
					</el-input>
				</el-form-item>
				<el-form-item label="最高击球速度" prop="maxHitSpeed">
					<el-input v-model.number="temp.maxHitSpeed" disabled placeholder="请输入最高击球速度" style="width:200px;">
						<i slot="suffix">km/h</i>
					</el-input>
				</el-form-item>
				<el-form-item label="上网次数" prop="netApproachCount">
					<el-input v-model.number="temp.netApproachCount" disabled placeholder="请输入上网次数" style="width:200px;">
					</el-input>
				</el-form-item>
				<el-form-item label="网前得分率" prop="netScoreRate">
					<el-input v-model.number="temp.netScoreRate" disabled placeholder="请输入网前得分率" style="width:200px;">
						<i slot="suffix">%</i>
					</el-input>
				</el-form-item>
				<el-form-item label="截击得分率" prop="volleyScoreRate">
					<el-input v-model.number="temp.volleyScoreRate" disabled placeholder="请输入截击得分率" style="width:200px;">
						<i slot="suffix">%</i>
					</el-input>
				</el-form-item>
				<br>
				<!-- <el-form-item label="图片" prop="card_images">
          <FileList v-model="temp.card_images" :item-width="80" :item-height="80" :limit="50" type="image" style="width:300px;" />
        </el-form-item>
        <br>
        <el-form-item label="视频" prop="card_video">
          <FileList v-model="temp.card_video" :item-width="80" :item-height="80" :limit="50" type="video" style="width:300px;" />
        </el-form-item> -->

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">
					取消
				</el-button>
				<el-button type="primary" @click="ConfirmData">
					保存
				</el-button>
			</div>
		</el-dialog>
		<!--弹窗详情窗体-->
		<el-dialog title="详情" :visible.sync="dialogDetailsVisible" width="1200px" top="10vh">
			<Details v-if="dialogDetailsVisible" :id="details_id"></Details>
		</el-dialog>
		<!--调整余额弹窗-->
		<el-dialog title="调整余额" :visible.sync="dialogAdjustVisible" width="620px" top="12vh" @closed="adjustClosed">
			<el-form ref="adjustForm" :model="adjustForm" label-width="110px" style="padding: 10px 10px 0 0;">
				<el-form-item label="目标用户">
					<el-input :value="adjustForm.nickname + '（' + adjustForm.phone + '）'" disabled />
				</el-form-item>
				<el-form-item label="调整类型" required>
					<el-radio-group v-model="adjustForm.adjust_type">
						<el-radio :label="1">增加</el-radio>
						<el-radio :label="2">减少</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="调整金额" required>
					<el-input-number v-model="adjustForm.money" :min="0.01" :precision="2" :step="1" style="width: 100%;" />
				</el-form-item>
				<el-form-item label="调整原因" required>
					<el-select v-model="adjustForm.reason" placeholder="请选择" clearable style="width: 100%;">
						<el-option label="线下充值" value="offline_recharge" />
						<el-option label="活动奖励" value="activity_reward" />
						<el-option label="客诉补偿" value="customer_compensation" />
						<el-option label="操作失误扣回" value="operation_error" />
						<el-option label="其他" value="other" />
					</el-select>
				</el-form-item>
				<el-form-item v-if="adjustForm.reason === 'other'" label="原因说明" required>
					<el-input v-model="adjustForm.reason_text" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="请选择「其他」时必填" />
				</el-form-item>
				<el-form-item label="备注说明">
					<el-input v-model="adjustForm.remark" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="选填" />
				</el-form-item>
				<el-form-item label="凭证上传">
					<FileList v-model="adjustForm.attachment" :item-width="80" :item-height="80" :limit="5" type="image" style="width: 300px;" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogAdjustVisible = false">取消</el-button>
				<el-button type="primary" :loading="adjustLoading" @click="ConfirmAdjust">提交审批</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import api from '@/api/user' // 和数据交互相关写在api 方便复用
	import { submitMoneyAdjust } from '@/api/user/userMoneyAdjust'
	import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
	import commonList from '@/utils/commonList'
	import FileList from '@/components/attachment/FileList'
	import Details from './details'
	export default {
		name: 'User',
		components: {
			Pagination,
			FileList,
			Details
		},
		// 列绑定格式化器
		filters: {
			genderFilter(val) {
				switch (val) {
					case 1:
						return '男'
					case 2:
						return '女'
					default:
						return '未知'
				}
			}
		},
		mixins: [commonList],
		data() {
			var validateBfb = (rule, value, callback) => {
				if (value < 0) {
					callback(new Error('不能是否负数，请重新输入'))
				} else if (value > 100) {
					callback(new Error('不能超过100，请重新输入'))
				} else {
					callback()
				}
			}
			var validateSpeed = (rule, value, callback) => {
				if (value < 0) {
					callback(new Error('不能是否负数，请重新输入'))
				} else {
					callback()
				}
			}

			return {
				base_url: process.env.VUE_APP_BASE_API,
				// api接口方法
				api,
				// 校验
				rules: {
					nickname: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, {
						pattern: /^1[3-9]\d{9}$/,
						message: '手机号码格式不正确',
						trigger: 'blur'
					}],
					gender: [{
						required: true,
						message: '请选择性别',
						trigger: ['blur', 'change']
					}],
					age: [{
						required: true,
						message: '请输入年龄',
						trigger: 'blur'
					}],
					serveSuccessRate: [{
						validator: validateBfb,
						trigger: 'blur'
					}],
					serveSpeed: [{
						validator: validateSpeed,
						trigger: 'blur'
					}],
					receiveSuccessRate: [{
						validator: validateBfb,
						trigger: 'blur'
					}],
					breakPointConversionRate: [{
						validator: validateBfb,
						trigger: 'blur'
					}],
					hitSuccessRate: [{
						validator: validateBfb,
						trigger: 'blur'
					}],
					forehandHitRate: [{
						validator: validateBfb,
						trigger: 'blur'
					}],
					backhandHitRate: [{
						validator: validateBfb,
						trigger: 'blur'
					}],
					baselineScoreRate: [{
						validator: validateBfb,
						trigger: 'blur'
					}],
					averageHitSpeed: [{
						validator: validateSpeed,
						trigger: 'blur'
					}],
					maxHitSpeed: [{
						validator: validateSpeed,
						trigger: 'blur'
					}],
					netApproachCount: [{
						validator: validateSpeed,
						trigger: 'blur'
					}],
					netScoreRate: [{
						validator: validateSpeed,
						trigger: 'blur'
					}],
					volleyScoreRate: [{
						validator: validateSpeed,
						trigger: 'blur'
					}]
				},
				temp: {},
				details_id: 0,
				dialogDetailsVisible: false,
				// 调整余额
				dialogAdjustVisible: false,
				adjustLoading: false,
				adjustForm: {
					user_id: null,
					nickname: '',
					phone: '',
					adjust_type: 1,
					money: null,
					reason: '',
					reason_text: '',
					remark: '',
					attachment: ''
				},
				// reason_text 不可写死 required：非「其他」时表单项隐藏，校验失败会无红字提示，表现为点击提交无反应
				adjustRules: {}
			}
		},
		created() {
			this.loadData() // 页面加载创建时加载数据
		},
		methods: {
			// 更新状态
			changeState(row) {
				this.api.SaveSimple({
					id: row.id,
					status: row.status
				}).then(response => {
					this.$notify({
						title: '成功',
						message: response.message,
						type: 'success'
					})
				})
			},
			changeBlacklist(row, type) {
				this.$confirm('您确定要“' + (type === 1 ? '加入黑名单' : '解除黑名单') + '”的操作吗?', (type === 1 ? '加入黑名单' : '解除黑名单'), {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.api.SaveBlackSimple({
						id: row.id
					}).then(response => {
						this.loadData()
						this.$notify({
							title: '成功',
							message: response.message,
							type: 'success'
						})
					})
				})
			},
			// 余额记录
			moneylsit(data) {
				this.$router.push({
					path: '/user/money',
					query: {
						id: data.id
					}
				})
			},
			// 打开调整余额弹窗
			HandleAdjustMoney(row) {
				this.adjustForm = {
					user_id: row.id,
					nickname: row.nickname || '',
					phone: row.phone || '',
					adjust_type: 1,
					money: null,
					reason: '',
					reason_text: '',
					remark: '',
					attachment: ''
				}
				this.dialogAdjustVisible = true
			},
			// 弹窗关闭后重置表单，避免下次打开时残留校验状态
			adjustClosed() {
				this.$refs.adjustForm && this.$refs.adjustForm.clearValidate()
			},
			// 提交调整余额审批
			ConfirmAdjust() {
				const { adjust_type, money, reason, reason_text } = this.adjustForm
				if (adjust_type !== 1 && adjust_type !== 2) {
					this.$message.warning('请选择调整类型（增加或减少）')
					return
				}
				if (money === null || money === undefined || money === '' || Number(money) <= 0) {
					this.$message.warning('请输入大于 0 的调整金额')
					return
				}
				if (!reason) {
					this.$message.warning('请选择调整原因')
					return
				}
				if (reason === 'other' && !String(reason_text || '').trim()) {
					this.$message.warning('调整原因为「其他」时，原因说明为必填')
					return
				}
				this.adjustLoading = true
				submitMoneyAdjust(this.adjustForm).then(() => {
					this.$message.success('提交成功，状态：待审批')
					this.dialogAdjustVisible = false
				}).finally(() => {
					this.adjustLoading = false
				})
			},
			resetTemp() {
				this.temp = {
					id: undefined,
					status: 1
				}
			},
			// 筛选
			filterHandler(value, row, column) {
				const property = column['property']
				return row[property] === value
			},
			HandleDetails(row) {
				this.details_id = row.id
				this.dialogDetailsVisible = true
			}
			// timestampToTime(row, column) {
			//   var date = new Date(row.login_time * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
			//   const Y = date.getFullYear() + '-'
			//   const M =
			//     date.getMonth() + 1 < 10
			//       ? '0' + (date.getMonth() + 1) + '-'
			//       : date.getMonth() + 1 + '-'
			//   const D =
			//     date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
			//   const h =
			//     date.getHours() < 10
			//       ? '0' + date.getHours() + ':'
			//       : date.getHours() + ':'
			//   const m =
			//     date.getMinutes() < 10
			//       ? '0' + date.getMinutes() + ':'
			//       : date.getMinutes() + ':'
			//   const s =
			//     date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
			//   return Y + M + D + h + m + s
			// },
		}
	}
</script>
<style scoped>
	.user-op-btns {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 6px 0;
		row-gap: 10px;
	}

	.user-op-row {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		column-gap: 8px;
		row-gap: 6px;
		width: 100%;
	}

	::-webkit-scrollbar {
		width: 5px;
		/* 定义滚动条的宽度 */
	}

	::-webkit-scrollbar-track {
		background: #ecf5ff;
		/* 定义轨道的背景颜色 */
	}

	::-webkit-scrollbar-thumb {
		background: #b3d8ff;
		/* 定义滑块的背景颜色 */
	}

	::-webkit-scrollbar-thumb:hover {
		background: #b3d8ff;
		/* 定义滑块在悬停状态下的背景颜色 */
	}
</style>